export const adjustEditProfileData = data => {
  const user = data.userId;
  let newData = {};
  if (user.userId) {
    newData.userId = user.userId;
  }
  if (data.roleId) {
    newData.role = data.roleId.role;
    newData.roleKey = data.roleId.roleKey;
  }
  if (user.lastname) {
    newData.lastname = user.lastname;
  }
  if (user.name) {
    newData.name = user.name;
  }
  if (user.patronymic) {
    newData.patronymic = user.patronymic;
  }
  if (user.birthDate) {
    newData.birthDate = user.birthDate;
  }
  if (user.phone) {
    let phone = user.phone.match(
      /^(\+7|\+380|\+375|\+995|\+374|\+994|\+77|)(.*)/
    );
    if (phone) {
      newData.phoneCode = phone[1];
      newData.phoneNumber = phone[2];
    }
  }
  /*
  if (user.birthPlace) {
    newData.birth_place = user.birthPlace;
  }
  if (user.sexId) {
    newData.sexId = user.sexId;
  }
  if (user.citizenshipId) {
    newData.citizenshipId = user.citizenshipId;
  }
  */
  if (user.email) {
    newData.email = user.email;
  }
  if (user.photo) {
    newData.photo = user.photo;
  }
  if (data.companyId) {
    newData.companyId = data.companyId.companyId;
  }

  return newData;
};
